"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.createQueuedStorage = void 0;
var createQueuedStorage_1 = require("./createQueuedStorage");
Object.defineProperty(exports, "createQueuedStorage", { enumerable: true, get: function () { return createQueuedStorage_1.createQueuedStorage; } });
